import parse from 'html-react-parser'
import Head from 'next/head'

import { FRONT_BASE_URL } from '@/constants'

import { WPPageData } from '@/types'

type MetaProps = {
  pageProps: WPPageData
}

const Meta = ({ pageProps }: MetaProps) => {
  const robotsContent = [
    pageProps?.meta_robots?.is_robots_noindex ? 'noindex' : 'index',
    pageProps?.meta_robots?.is_robots_nofollow ? 'nofollow' : 'follow'
  ]
    .filter(Boolean)
    .join(', ')

  return pageProps?.yoast_head ? (
    <Head>
      {parse(pageProps.yoast_head.replace(/"\//g, `"${FRONT_BASE_URL}/`) || '')}
      {robotsContent ? <meta name="robots" content={robotsContent} /> : null}

      {pageProps?.wpml_translations?.length > 0
        ? pageProps.wpml_translations.map((translation, index) => (
            <link
              key={`${translation.id}${index}`}
              rel="alternate"
              hrefLang={translation.code}
              href={`${FRONT_BASE_URL}${translation.href}`}
            />
          ))
        : null}

      {pageProps?.xdefault_translation?.length > 0
        ? pageProps.xdefault_translation.map((translation, index) => (
            <link
              key={`${translation.id}${index}`}
              rel="alternate"
              hrefLang="x-default"
              href={`${FRONT_BASE_URL}${translation.href}`}
            />
          ))
        : null}
    </Head>
  ) : null
}

export default Meta
